export default __webpack_public_path__ + "static/media/Green.43ee1835.gif";